module.exports = __webpack_public_path__ + "img/jixianghundun .58839279.png";